module.exports = __webpack_public_path__ + "img/logos.513dfec8.png";